import { toast } from 'sonner';
import { getApiErrorMessage } from '@/services/api';

type NotifyOptions = {
  description?: string;
  duration?: number;
};

export const notify = {
  success(message: string, options?: NotifyOptions) {
    toast.success(message, {
      description: options?.description,
      duration: options?.duration ?? 4000,
    });
  },

  error(message: string, options?: NotifyOptions) {
    toast.error(message, {
      description: options?.description,
      duration: options?.duration ?? 5000,
    });
  },

  info(message: string, options?: NotifyOptions) {
    toast.info(message, {
      description: options?.description,
      duration: options?.duration ?? 4000,
    });
  },

  /** Show a friendly message from an API or thrown error. */
  apiError(error: unknown, fallback = 'Something went wrong') {
    toast.error(getApiErrorMessage(error, fallback));
  },

  /** Show success using an API message when present. */
  apiSuccess(message?: string | null, fallback = 'Completed successfully') {
    toast.success(message?.trim() || fallback);
  },
};
